import { useComputed } from "@suse-o11y/signal";
import React from "react";

import { useQuery } from "../../../../queries/react-query";
import { useDashboardContext } from "../_dashboard-context";
import { queryMetricPromQLOptions } from "../_dynamic-variable-query";

import { ListMultiChoiceVariable, type ListMultiChoiceVariableProps } from "./_list-multi-choice";
import { ListSingleChoiceVariable, type ListSingleChoiceVariableProps } from "./_list-single-choice";

type MultiChoiceProps = {
	allowMultiple: true;
} & Omit<ListMultiChoiceVariableProps, "options">;

type SingleChoiceProps = { allowMultiple: false } & Omit<ListSingleChoiceVariableProps, "options">;

type Props = {
	expression: string;
	label: string;
} & (MultiChoiceProps | SingleChoiceProps);

export const MetricsPromQLVariable = ({ expression, label, ...props }: Props) => {
	const { chartTimeRange } = useDashboardContext();
	const [dropdownVisible, setDropdownVisible] = React.useState(false);

	const query = queryMetricPromQLOptions({
		expression,
		label,
		timeRange: useComputed(chartTimeRange),
	});

	const { data, error } = useQuery({
		...query,
		enabled: dropdownVisible && query.enabled !== false,
		keepPreviousData: true,
	});

	const options =
		query.enabled === false || error || data == null ? [] : data.map((value) => ({ value, label: value }));

	if (props.allowMultiple) {
		return <ListMultiChoiceVariable {...props} onDropdownVisibleChange={setDropdownVisible} options={options} />;
	}

	return <ListSingleChoiceVariable {...props} onDropdownVisibleChange={setDropdownVisible} options={options} />;
};
